import client from "api/client";


const _client = client.route("/user");

const user = {
	get: () => _client.get(),
	edit: (payload) => _client.post("/edit", payload),
	partnerCreation: () => _client.get("/partner-creation")
};

export default user;